import React from 'react';
import Logs from '../../../../../src/assets/images/studio/ingestion/logs.svg';

interface LogsIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  style?: React.CSSProperties;
}

export default function LogsIconComponent({ style, ...props }: LogsIconProps) {
  return <img {...props} alt="logs icon" src={Logs} style={{ ...style }} />;
}
